/** 通常パウチの value 丸め（小数第2位）。時間パウチの分は別途整数。 */

export const POUCH_VALUE_DECIMAL_PLACES = 2;

const POUCH_VALUE_SCALE = 10 ** POUCH_VALUE_DECIMAL_PLACES;

/** 帳尻パウチの近傍探索ステップ（value の最小刻み） */
export const POUCH_VALUE_STEP = 1 / POUCH_VALUE_SCALE;

/** パウチ値を小数第2位で四捨五入（符号付き） */
export function roundPouchValue(value: number): number {
  if (!Number.isFinite(value)) return value;
  return Math.round(value * POUCH_VALUE_SCALE) / POUCH_VALUE_SCALE;
}

/** 時間パウチの実効分（整数分） */
export function roundTimePouchMinutes(minutes: number): number {
  if (!Number.isFinite(minutes)) return minutes;
  return Math.round(minutes);
}
